// TO CREATE FLN ACTIVITY TOPIC

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import { purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  usertype_change,
  assessmentType_change,
  language_change,
  clas_change,
  subject_change,
  clearData,
} from "./FlnTopicsSlice";
import {
  getMasterStudActTopicsThunk,
  deleteTeacherBaselineThunk,
} from "./FlnTopicsThunk";
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";
import { getMediaUrl } from "../../utils/mediaUtils";

const FlnTopicsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const Topic = useSelector((state) => state.FlnTopicsSlice.data);

  // -------------- Card-item vertical menu ---------------
  const [recordId, setRecordId] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id) => {
    setAnchorEl(event.currentTarget);
    setRecordId(_id);
  };
  const [updateData, setUpdateData] = useState({
    topicId: "",
    topicName: "",
    topicImage: "",
  });

  const [loading, setLoading] = useState(false);
  const [topicNameInput, setTopicNameInput] = useState("");
  const [createTopicModal, setCreateTopicModal] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [file, setFile] = useState("");

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ------------ Load data & topic ----------------
  const usertype = useSelector((state) => state.FlnTopicsSlice.usertype);
  const language = useSelector((state) => state.FlnTopicsSlice.language);
  const assessmentType = useSelector(
    (state) => state.FlnTopicsSlice.assessmentType
  );
  const clas = useSelector((state) => state.FlnTopicsSlice.clas);
  const subject = useSelector((state) => state.FlnTopicsSlice.subject);

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "cci", text: "CCI" },
  ];

  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const assessmentType_select_option_list = [
    { id: 0, value: "formative", text: "Formative Assessment" },
    { id: 1, value: "summative", text: "Summative Assessment" },
  ];

  const clas_select_option_list = [
    { value: "SV", text: "Shishu Vatika" },
    ...Array.from({ length: 10 }, (_, i) => ({
      value: String(i + 1),
      text: `Class ${i + 1}`,
    })),
  ];

  const subject_select_option_list = [
    { value: "maths", text: "Maths" },
    { value: "english", text: "English" },
    { value: "odia", text: "Odia" },
    { value: "evs", text: "EVS" },
    { value: "numeracy", text: "Numeracy" },
    { value: "literacy", text: "Literacy" },
    { value: "sst", text: "SST" },
    { value: "science", text: "Science" },
  ];

  // ------------ fetch helper ----------------
  const fetchTopics = (params) => {
    dispatch(
      getMasterStudActTopicsThunk({
        usertype: params.usertype,
        language: params.language,
        assessType: params.assessmentType,
        quizClass: params.clas,
        subject: params.subject,
      })
    );
  };

  // ------------ dropdowns on change ----------------
  const language_select_onchange = (event) => {
    dispatch(language_change(event.target.value));
  };

  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };

  const assessmentType_select_onchange = (event) => {
    dispatch(assessmentType_change(event.target.value));
  };

  const clas_select_onchange = (event) => {
    dispatch(clas_change(event.target.value));
  };

  const subject_select_onchange = (event) => {
    dispatch(subject_change(event.target.value));
    fetchTopics({
      usertype,
      language,
      assessmentType,
      clas,
      subject: event.target.value,
    });
  };

  const navigate_to = () => {
    clearState();
    navigate("/flnactivity");
  };

  //*-----------------For selecting and displaying the image-----------------
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const maxHeight = 612;
    const maxWidth = 612;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (file.size > 1048578) {
        toast.error("File size exceeds the maximum allowed (1 MB)");
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          const { width, height } = img;

          if (width > maxWidth || height > maxHeight) {
            toast.error("Maximum height and width exceeded");
            setSelectedImage(null);
            return;
          }

          if (fileExtension === "png" || fileType === "image/png") {
            setImageName(`studAct_topic_${new Date().getTime()}.png`);
          } else if (
            fileExtension === "jpg" ||
            fileExtension === "jpeg" ||
            fileType === "image/jpeg"
          ) {
            setImageName(`studAct_topic_${new Date().getTime()}.jpg`);
          } else {
            console.log("It is neither a PNG nor a JPG file.");
            return;
          }

          setSelectedImage(file);
          setFile(e.target.result);
        };
      };

      reader.readAsDataURL(file);
    }
  };

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    setCreateTopicModal(true);
    setTopicNameInput("");
  };

  const closeTopicModal = () => {
    setCreateTopicModal(false);
    setTopicNameInput("");
    setSelectedImage(null);
    setFile("");
  };

  const handleTopicSave = async () => {
    setLoading(true);
    if (topicNameInput.trim() === "" || !topicNameInput) {
      toast.error("Please enter a topic name");
      setLoading(false);
    } else if (!selectedImage && assessmentType === "formative") {
      toast.error("Please select an image before proceeding!");
      setLoading(false);
    } else {
      let finalImageUrl = imageName;
      if (selectedImage) {
        const uploadResult = await UploadFileToAzureDB(selectedImage, imageName);
        if (!uploadResult?.success) {
          setLoading(false);
          return;
        }
        finalImageUrl = uploadResult.url || imageName;
      }

      const body = {
        topicId: new Date().getTime(),
        usertype: usertype,
        language: language,
        quizClass: clas,
        subject: subject,
        topicName: topicNameInput.trim(),
        assessType: assessmentType,
        topicImage: finalImageUrl,
      };

      api
        .post(`saveMasterStudActTopic`, body)
        .then((response) => {
          if (Object.keys(response.data).length > 0) {
            fetchTopics({ usertype, language, assessmentType, clas, subject });
            toast.success("Changes made successfully");
            setLoading(false);
            setCreateTopicModal(false);
            setTopicNameInput("");
            setSelectedImage(null);
            setFile("");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 413) {
            toast.error("The file is too large to upload");
            console.error("The error is:", error);
          } else if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("Error:", error);
          }
        });
    }
  };

  const openUpdateModal = (eachskill) => {
    setShowUpdate(true);
    setUpdateData({
      topicId: eachskill.topicId,
      topicName: eachskill.topicName,
      topicImage: eachskill.topicImage ? eachskill.topicImage : "",
    });
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
    setFile("");
    setSelectedImage(null);
  };

  const updateTopicData = async () => {
    if (updateData.topicName === "" || updateData.topicName.trim() === "") {
      toast.error("The topic name can't be empty !");
    } else if (
      !updateData.topicImage &&
      !file &&
      assessmentType === "formative"
    ) {
      toast.error("Please select an image!");
    } else {
      let finalImageUrl = updateData?.topicImage
        ? getMediaUrl(updateData.topicImage)
        : "";
      if (file && selectedImage) {
        const uploadResult = await UploadFileToAzureDB(selectedImage, imageName);
        if (!uploadResult?.success) {
          return;
        }
        finalImageUrl = uploadResult.url || imageName;
      }

      const data = {
        topicId: updateData?.topicId,
        topicName: updateData?.topicName,
        topicImage: finalImageUrl,
      };
      api
        .patch(`updateMasterStudActTopic`, data)
        .then(
          (response) => {
            if (response.status === 200) {
              fetchTopics({ usertype, language, assessmentType, clas, subject });
              setShowUpdate(false);
              setFile("");
              setSelectedImage(null);
              setImageName("");
              toast.success("Changes made successfully");
            }
          },
          (err) => {
            console.log(err);
            toast.error("Enter a valid skill");
          }
        )
        .catch((error) => {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          return false; // Prevent Swal from closing
        });
    }
  };

  const deleteImageForUpdate = (item) => {
    deleteFileFromDB(item?.topicImage);
    setUpdateData({ ...item, topicImage: "" });
  };

  const delete_content_button_click = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFileFromDB(item?.topicImage);
        dispatch(deleteTeacherBaselineThunk(item.topicId))
          .then(() => {
            fetchTopics({ usertype, language, assessmentType, clas, subject });
            toast.success("Changes made successfully");
          })
          .catch((error) => {
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
            return false; // Prevent Swal from closing
          });
      }
    });
  };

  const clearState = () => {
    dispatch(clearData());
  };

  return (
    <>
      <div>
        <MuiHeader header="TOPIC" />
        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">AssessType</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={assessmentType}
            label="AssessType"
            onChange={assessmentType_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language &&
              usertype &&
              assessmentType_select_option_list.map((option) => (
                <MenuItem key={option.id} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Class</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={clas}
            label="Class"
            onChange={clas_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language &&
              usertype &&
              assessmentType &&
              clas_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Subject</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={subject}
            label="Subject"
            onChange={subject_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language &&
              usertype &&
              assessmentType &&
              clas &&
              subject_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        {usertype && language && assessmentType && clas && subject ? (
          <Button
            onClick={create_content_button_click}
            variant="contained"
          >
            <AddIcon />
            Create New Topic
          </Button>
        ) : null}

        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "black",
          }}
          size="small"
        >
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>

      {/** //&----------------Create Topic Modal--------------------------- */}
      <Modal open={createTopicModal} onClose={closeTopicModal}>
        <Box sx={style}>
          <TextField
            id="outlined-multiline-static"
            label="Topic Name"
            multiline
            rows={2}
            variant="outlined"
            sx={{
              width: 250,
              marginTop: 2,
              marginLeft: 4,
            }}
            size="small"
            value={topicNameInput}
            onChange={(e) => setTopicNameInput(e.target.value)}
          />
          <br />
          <div style={{ marginLeft: "33px", marginTop: "10px" }}>
            <input type="file" accept="image/*" onChange={handleImageChange} />
            {file && (
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                <img
                  src={file}
                  alt="Selected"
                  style={{ maxWidth: "100%", marginTop: "10px" }}
                />
              </div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              onClick={closeTopicModal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              onClick={handleTopicSave}
              disabled={loading}
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>

      {/** //^----------------Update Modal--------------------------- */}
      <Modal open={showUpdate} onClose={handleCloseUpdate}>
        <Box sx={style}>
          <TextField
            id="outlined-multiline-static"
            label="Topic Name"
            multiline
            rows={2}
            variant="outlined"
            sx={{
              width: 250,
              marginTop: 2,
              marginLeft: 4,
            }}
            size="small"
            value={updateData?.topicName}
            onChange={(e) =>
              setUpdateData({ ...updateData, topicName: e.target.value })
            }
          />
          <br />
          <div style={{ marginLeft: "33px", marginTop: "10px" }}>
            {updateData.topicImage ? (
              <Button
                variant="contained"
                style={{ backgroundColor: "red" }}
                onClick={() => deleteImageForUpdate(updateData)}
              >
                Delete Image
              </Button>
            ) : (
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            )}
            {(file || updateData.topicImage) && (
              <div style={{ maxHeight: "300px", overflowY: "hidden" }}>
                <img
                  src={
                    file
                      ? file
                      : updateData.topicImage
                        ? getMediaUrl(updateData.topicImage)
                        : ""
                  }
                  alt="Selected"
                  style={{ maxWidth: "100%", marginTop: "10px" }}
                />
              </div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              onClick={handleCloseUpdate}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              onClick={updateTopicData}
              disabled={loading}
            >
              Update
            </Button>
          </div>
        </Box>
      </Modal>
      {/* Show List */}
      <div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            <>
              {subject && Topic?.length > 0
                ? Topic?.map((eachTopic, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={isSmallScreen ? 12 : 6}
                    md={4}
                    key={index}
                  >
                    <Card sx={{ maxWidth: 345 }}>
                      <CardHeader
                        avatar={
                          eachTopic.topicImage ? (
                            <img
                              src={getMediaUrl(eachTopic.topicImage)}
                              style={{
                                height: "60px",
                                width: "60px",
                                borderRadius: "10px",
                              }}
                            />
                          ) : (
                            <Avatar
                              sx={{
                                bgcolor: purple[500],
                                width: "53px",
                                height: "53px",
                              }}
                            >
                              <AodIcon />
                            </Avatar>
                          )
                        }
                        action={
                          <>
                            <IconButton
                              id={index + 1.1}
                              onClick={(e) =>
                                handleVertMenuClick(e, eachTopic.topicId)
                              }
                              aria-expanded={
                                openVertMenu ? "true" : undefined
                              }
                              aria-haspopup="true"
                            />
                          </>
                        }
                        title={
                          <div
                            style={{
                              cursor: "pointer",
                              wordBreak: "break-all",
                            }}
                          >
                            {eachTopic.topicName}
                          </div>
                        }
                      />
                      <Button
                        onClick={() => delete_content_button_click(eachTopic)}
                      >
                        Delete
                      </Button>
                      <Button onClick={() => openUpdateModal(eachTopic)}>
                        Edit
                      </Button>
                    </Card>
                  </Grid>
                ))
                : ""}
            </>
          </Grid>
        </Box>
      </div>

      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default FlnTopicsPage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
